import { RouterView } from "vue-router";
import { EntityDocuments } from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  swmps: "Swmp.Swmps",
  list: "Swmp.SwmpList",
  new: "Swmp.SwmpNew",
  base: "Swmp.SwmpBase",
  view: "Swmp.SwmpView",
  edit: "Swmp.SwmpEdit",
  notes: "Swmp.SwmpNotes",
  noteEdit: "Swmp.SwmpNoteEdit",
  noteNew: "Swmp.SwmpNoteNew",
  documents: "Swmp.SwmpDocuments",
  documentEdit: "Swmp.SwmpDocumentEdit",
  documentNew: "Swmp.SwmpDocumentNew",
};

export { names as swmpRouteNames };

/** @type {import('vue-router').RouterOptions['routes']} */
const swmpRoutes = [
  {
    path: "/swmps",
    name: names.swmps,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Solid Waste Management Plans", lookupGroups: ["County"] },
        component: () => import("@/views/swmp/SwmpList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/swmp/SwmpBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "SWMP View" },
            component: () => import("@/views/swmp/SwmpView.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "SWMP Internal Notes" },
            component: {
              render: () => <EntityNotes idField="swmpId" routeNamePrefix="Swmp.SwmpNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit SWMP Internal Note", isForm: true },
            component: () => import("@/views/swmp/SwmpNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create SWMP Internal Note", isForm: true },
            component: () => import("@/views/swmp/SwmpNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "SWMP Documents" },
            component: {
              render: () => <EntityDocuments idField="swmpId" routeNamePrefix="Swmp.SwmpDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit SWMP Document", isForm: true },
            component: () => import("@/views/swmp/SwmpDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create SWMP Document", isForm: true },
            component: () => import("@/views/swmp/SwmpDocuments.vue"),
          },
        ],
      },
    ],
  },
];
export default swmpRoutes;
